import Vue from 'vue'
import { URL_USER_PROXIES } from '@/constants/urls.js'
import { CURRENT_USER_PROXIES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CURRENT_USER_PROXIES.STATE.PROXIES]: null
}

const actions = {
  async [CURRENT_USER_PROXIES.ACTIONS.GET_CURRENT_USER_PROXY_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROXIES}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CURRENT_USER_PROXIES.MUTATIONS.GET_CURRENT_USER_PROXY_LIST, resp.data)
  },
  async [CURRENT_USER_PROXIES.ACTIONS.CREATE_USER_PROXY] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROXIES}`,
      model: model.proxy
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [CURRENT_USER_PROXIES.ACTIONS.CLEAR_CURRENT_USER_PROXY_LIST] ({ commit }) {
    commit(CURRENT_USER_PROXIES.MUTATIONS.CLEAR_CURRENT_USER_PROXY_LIST)
  }
}

const mutations = {
  [CURRENT_USER_PROXIES.MUTATIONS.GET_CURRENT_USER_PROXY_LIST] (state, proxies) {
    state[CURRENT_USER_PROXIES.STATE.PROXIES] = proxies
  },
  [CURRENT_USER_PROXIES.MUTATIONS.CLEAR_CURRENT_USER_PROXY_LIST] (state) {
    state[CURRENT_USER_PROXIES.STATE.PROXIES] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
